function camelize(s) {
    return s.replace(/([-_][a-z])/gi, char => char.toUpperCase().replace('-', '').replace('_', ''));
}
function kebalize(s) {
    return s.replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase();
}
export default function normalizeCSSModules(raw) {
    return Object.keys(raw).reduce((res, key) => {
        const style = raw[key];
        res[kebalize(key)] = style;
        res[camelize(key)] = style;
        res[key] = style;
        return res;
    }, {});
}
//# sourceMappingURL=css-modules.js.map